// Lastik marka bazlı SEO landing page verileri

export const BRAND_PAGES = [
  {
    slug: 'goodyear-lastik-kocaeli',
    name: 'Goodyear',
    logo: '/images/brands/goodyear.webp',
    title: 'Goodyear Lastik Kocaeli | 7/24 Goodyear Lastik Satış ve Montaj',
    metaDesc: 'Kocaeli Goodyear lastik satış, montaj ve değişimi. Goodyear lastik fiyatları ve 7/24 yerinde montaj hizmeti. İzmit, Gebze tüm ilçelere.',
    intro: 'Goodyear lastik Kocaeli yetkili satış ve montaj noktası. Goodyear yaz, kış ve 4 mevsim lastiklerini stokumuzda bulunduruyoruz. 7/24 yerinde Goodyear lastik montajı hizmeti.',
    features: ['Goodyear EfficientGrip serisi', 'Goodyear UltraGrip kış lastikleri', 'Goodyear Eagle spor lastikler', 'Goodyear Wrangler SUV lastikleri'],
    faqs: [{ q: 'Goodyear lastik fiyatları ne kadar?', a: 'Goodyear lastik fiyatları ebada ve modele göre değişir. Arayarak güncel fiyat bilgisi alabilirsiniz.' }, { q: 'Goodyear lastik montajı yerinde yapılıyor mu?', a: 'Evet, Goodyear lastikleri stokumuzdadır ve 7/24 yerinde montaj yapıyoruz.' }],
  },
  {
    slug: 'michelin-lastik-kocaeli',
    name: 'Michelin',
    logo: '/images/brands/michelin.webp',
    title: 'Michelin Lastik Kocaeli | 7/24 Michelin Lastik Satış ve Montaj',
    metaDesc: 'Kocaeli Michelin lastik satış, montaj ve değişimi. Michelin lastik fiyatları ve 7/24 yerinde montaj hizmeti. İzmit, Gebze tüm ilçelere.',
    intro: 'Michelin lastik Kocaeli yetkili satış noktası. Michelin Primacy, Pilot Sport, Alpin kış lastikleri stokta. 7/24 yerinde Michelin lastik montajı hizmeti.',
    features: ['Michelin Primacy konfor lastikleri', 'Michelin Pilot Sport performans', 'Michelin Alpin kış lastikleri', 'Michelin CrossClimate 4 mevsim'],
    faqs: [{ q: 'Michelin lastik fiyatları ne kadar?', a: 'Michelin lastik fiyatları model ve ebada göre değişir. Arayarak güncel fiyat alabilirsiniz.' }, { q: 'Michelin kış lastiği var mı?', a: 'Evet, Michelin Alpin serisi kış lastiklerini stokumuzda bulunduruyoruz.' }],
  },
  {
    slug: 'bridgestone-lastik-kocaeli',
    name: 'Bridgestone',
    logo: '/images/brands/bridgestone.webp',
    title: 'Bridgestone Lastik Kocaeli | 7/24 Bridgestone Satış ve Montaj',
    metaDesc: 'Kocaeli Bridgestone lastik satış, montaj ve değişimi. Bridgestone lastik fiyatları ve 7/24 yerinde montaj. İzmit, Gebze tüm ilçelere.',
    intro: 'Bridgestone lastik Kocaeli satış noktası. Bridgestone Turanza, Potenza, Blizzak lastikleri stokta. 7/24 yerinde Bridgestone lastik montajı.',
    features: ['Bridgestone Turanza konfor', 'Bridgestone Potenza performans', 'Bridgestone Blizzak kış', 'Bridgestone Dueler SUV/4x4'],
    faqs: [{ q: 'Bridgestone lastik fiyatları ne kadar?', a: 'Bridgestone lastik fiyatları ebada göre değişir. Arayarak güncel fiyat alabilirsiniz.' }],
  },
  {
    slug: 'lassa-lastik-kocaeli',
    name: 'Lassa',
    logo: '/images/brands/lassa.webp',
    title: 'Lassa Lastik Kocaeli | 7/24 Lassa Lastik Satış ve Montaj',
    metaDesc: 'Kocaeli Lassa lastik satış, montaj ve değişimi. Yerli Lassa lastik fiyatları ve 7/24 yerinde montaj hizmeti. İzmit, Gebze tüm ilçelere.',
    intro: 'Lassa lastik Kocaeli satış noktası. Türkiye\'nin yerli markası Lassa\'nın tüm modellerini uygun fiyatla sunuyoruz. 7/24 yerinde Lassa lastik montajı.',
    features: ['Lassa Snoways kış lastikleri', 'Lassa Driveways yaz lastikleri', 'Lassa Multiways 4 mevsim', 'Lassa Competus SUV lastikleri'],
    faqs: [{ q: 'Lassa lastik fiyatları ne kadar?', a: 'Lassa, uygun fiyatlı yerli markadır. Ebada göre fiyat değişir, arayarak bilgi alabilirsiniz.' }, { q: 'Lassa kış lastiği kaliteli mi?', a: 'Evet, Lassa Snoways serisi kış lastikleri Brisa/Bridgestone teknolojisi ile üretilir.' }],
  },
  {
    slug: 'pirelli-lastik-kocaeli',
    name: 'Pirelli',
    logo: '/images/brands/pirelli.webp',
    title: 'Pirelli Lastik Kocaeli | 7/24 Pirelli Lastik Satış ve Montaj',
    metaDesc: 'Kocaeli Pirelli lastik satış, montaj ve değişimi. Pirelli P Zero, Cinturato lastik fiyatları ve 7/24 yerinde montaj.',
    intro: 'Pirelli lastik Kocaeli satış noktası. Pirelli P Zero, Cinturato, Scorpion serisi lastikler stokta. 7/24 yerinde Pirelli lastik montajı.',
    features: ['Pirelli P Zero yüksek performans', 'Pirelli Cinturato konfor', 'Pirelli Scorpion SUV/4x4', 'Pirelli Winter Sottozero kış'],
    faqs: [{ q: 'Pirelli lastik fiyatları ne kadar?', a: 'Pirelli premium segment bir markadır. Fiyatlar model ve ebada göre değişir, arayarak bilgi alabilirsiniz.' }],
  },
  {
    slug: 'continental-lastik-kocaeli',
    name: 'Continental',
    logo: '/images/brands/continental.webp',
    title: 'Continental Lastik Kocaeli | 7/24 Continental Satış ve Montaj',
    metaDesc: 'Kocaeli Continental lastik satış, montaj ve değişimi. Continental lastik fiyatları ve 7/24 yerinde montaj hizmeti.',
    intro: 'Continental lastik Kocaeli satış noktası. Continental PremiumContact, SportContact, WinterContact lastikler stokta. 7/24 yerinde montaj.',
    features: ['Continental PremiumContact konfor', 'Continental SportContact performans', 'Continental WinterContact kış', 'Continental CrossContact SUV'],
    faqs: [{ q: 'Continental lastik fiyatları ne kadar?', a: 'Continental fiyatları model ve ebada göre değişir. Arayarak güncel fiyat alabilirsiniz.' }],
  },
  {
    slug: 'petlas-lastik-kocaeli',
    name: 'Petlas',
    logo: '/images/brands/petlas.webp',
    title: 'Petlas Lastik Kocaeli | 7/24 Petlas Lastik Satış ve Montaj',
    metaDesc: 'Kocaeli Petlas lastik satış, montaj ve değişimi. Yerli Petlas lastik fiyatları ve 7/24 yerinde montaj. İzmit, Gebze tüm ilçelere.',
    intro: 'Petlas lastik Kocaeli satış noktası. Türkiye\'nin yerli markası Petlas\'ın tüm modellerini stokta bulunduruyoruz. 7/24 yerinde Petlas lastik montajı.',
    features: ['Petlas Velox Sport performans', 'Petlas SnowMaster kış', 'Petlas Imperium ekonomik', 'Petlas Full Power ticari'],
    faqs: [{ q: 'Petlas lastik kaliteli mi?', a: 'Evet, Petlas Türkiye\'nin en büyük lastik üreticisidir ve uluslararası kalite standartlarına sahiptir.' }, { q: 'Petlas lastik fiyatları ne kadar?', a: 'Petlas, uygun fiyatlı yerli markadır. Ebada göre değişir, arayarak bilgi alabilirsiniz.' }],
  },
  {
    slug: 'hankook-lastik-kocaeli',
    name: 'Hankook',
    logo: '/images/brands/hankook.webp',
    title: 'Hankook Lastik Kocaeli | 7/24 Hankook Lastik Satış ve Montaj',
    metaDesc: 'Kocaeli Hankook lastik satış, montaj ve değişimi. Hankook lastik fiyatları ve 7/24 yerinde montaj hizmeti.',
    intro: 'Hankook lastik Kocaeli satış noktası. Hankook Ventus, Kinergy, Winter i*cept lastikler stokta. 7/24 yerinde Hankook lastik montajı.',
    features: ['Hankook Ventus performans', 'Hankook Kinergy konfor', 'Hankook Winter i*cept kış', 'Hankook Dynapro SUV/4x4'],
    faqs: [{ q: 'Hankook lastik fiyatları ne kadar?', a: 'Hankook, orta-premium segmenttir. Fiyatlar model ve ebada göre değişir.' }],
  },
];

export const ALL_BRAND_SLUGS = BRAND_PAGES.map(b => b.slug);
export const getBrandBySlug = (slug) => BRAND_PAGES.find(b => b.slug === slug);
